(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ===== Mega Menu Logic ===== */
  function initYrMegaMenu() {
    const trigger = document.getElementById('yr-megamenu-trigger');
    const megamenu = document.getElementById('yr-megamenu');
    const overlay = document.getElementById('yr-megamenu-overlay');
    const shopLink = document.getElementById('yr-shop-link');
    if (!trigger || !megamenu || !overlay || !shopLink) {
      return;
    }
    /* Prevent double-init */
    if (shopLink.dataset.yrMegaInit === '1') return;
    shopLink.dataset.yrMegaInit = '1';
    let closeTimer = null;
    let isOpen = false;

    function openMega() {
      clearTimeout(closeTimer);
      if (isOpen) return;
      isOpen = true;
      trigger.classList.add('active');
      megamenu.classList.add('active');
      overlay.classList.add('active');
      shopLink.setAttribute('aria-expanded', 'true');
    }

    function closeMega() {
      isOpen = false;
      trigger.classList.remove('active');
      megamenu.classList.remove('active');
      overlay.classList.remove('active');
      shopLink.setAttribute('aria-expanded', 'false');
    }

    function delayedClose() {
      closeTimer = setTimeout(closeMega, 180);
    }

    // Desktop: hover to open, mouseout to close with delay
    trigger.addEventListener('mouseenter', openMega);
    trigger.addEventListener('mouseleave', delayedClose);
    megamenu.addEventListener('mouseenter', function() {
      clearTimeout(closeTimer);
    });
    megamenu.addEventListener('mouseleave', delayedClose);

    // Click on SHOP link: toggle mega menu on desktop, never navigate
    shopLink.addEventListener('click', function(e) {
      e.preventDefault();
      if (window.innerWidth > 768) {
        if (isOpen) {
          closeMega();
        } else {
          openMega();
        }
      }
    });

    // Overlay click closes mega
    overlay.addEventListener('click', closeMega);

    // Escape key closes mega
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isOpen) {
        closeMega();
        shopLink.focus();
      }
    });

    // Close mega menu on link click inside it
    megamenu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        closeMega();
      });
    });

    /* ===== Mobile Accordion & Nav handlers removed from this block ===== */
  }
  /* Init on DOM ready + section reload (for theme editor) */
  if (document.readyState !== 'loading') {
    initYrMegaMenu();
  } else {
    document.addEventListener('DOMContentLoaded', initYrMegaMenu);
  }
  document.addEventListener('shopify:section:load', function(e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#yr-megamenu-trigger')) {
      initYrMegaMenu();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
